import styles from "./Card.module.css";
const Card = (props) => {
  let classes;
  if (props.className) {
    classes = styles.card + " " + props.className;
  } else {
    classes = styles.card;
  }

  return (
    <div className={classes}>
      {props.children}
    </div>
  );
};

export default Card;
